<template>
    <div class="modal-content m-productPrices">
        <div class="modal-contentWrap">
            <div class="modal-header bg-1">
                <modal-close />

                <div class="modal-title text-center mb-0 mb-md-2">
                    <h2 class="h3 mb-1" v-text="'Ustaw cenę produktu'" />
                    <h5
                        class="mb-0"
                        v-text="product.name || product.dict_product.name"
                    />
                    <h6 v-text="product.ean" />
                </div>
            </div>

            <div class="modal-body px-2 py-4 px-sm-4">
                <div
                    class="d-flex align-items-end flex-column gap-1 mb-2 pb-4 border-bottom"
                >
                    <div class="d-flex gap-0-5">
                        <money-input
                            class="mb-0"
                            style="width: 8.5rem"
                            :price="0"
                            :label="'Cena w promocji'"
                            @onChange="massPrice = $event"
                        ></money-input>
                        <the-btn
                            v-tooltip="'Zastosuj cenę do wszystkich sklepów'"
                            text="Zastosuj dla wszystkich"
                            @click.native="
                                onMassPriceChange((+massPrice).toFixed(2))
                                componentKey++
                            "
                        />
                    </div>
                    <div class="d-flex gap-0-5" v-if="!product.ean_present">
                        <local-code
                            class="mb-0"
                            style="width: 8.5rem"
                            label="Kod lokalny"
                            :product="product"
                            @input="massCode = $event"
                        />
                        <the-btn
                            v-tooltip="'Zastosuj kod do wszystkich sklepów'"
                            text="Zastosuj dla wszystkich"
                            @click.native="
                                onMassLocalCodeChange(massCode)
                                checkIfEanExists()
                                componentKey++
                            "
                        />
                    </div>
                </div>

                <a-switch
                    v-if="false"
                    :checked="equalPrices"
                    @change="equalPrices = !equalPrices"
                    :text="'Jednakowa cena w wybranych sklepach'"
                />

                <shops-prices
                    :key="componentKey"
                    :merchants="merchants"
                    :product="product"
                />
            </div>
            <div
                class="modal-footer"
                style="position: sticky; bottom: 0; background: white"
            >
                <the-btn
                    class="ml-auto"
                    text="Zapisz i zamknij"
                    @click.native="
                        saveChanges()
                        $store.dispatch('toggleModal', false)
                    "
                />
            </div>
        </div>
    </div>
</template>

<script>
import { addNewPromo } from '@/mixins/addNewPromo'
import ShopsPrices from '@/components/promotions/addNewPromo/ShopsPrices'

export default {
    name: 'ProductPrices',
    mixins: [addNewPromo],
    components: {
        ShopsPrices
    },
    data() {
        return {
            componentKey: 0,
            massPrice: 0,
            massCode: '0',
            equalPrices: false,
            tempSelectedProducts: []
        }
    },
    created() {
        this.tempSelectedProducts = JSON.parse(JSON.stringify(this.isMix
            ? this.form.step3.product_sets[0].products.value
            : this.form.step3.products.value))
    },
    computed: {
        modalArgs() {
            return this.$store.getters.modalState.args
        },
        productId() {
            return this.modalArgs.product.id
        },
        merchants() {
            return this.selectedMerchants
        },
        product() {
            return this.tempSelectedProducts.find(
                prod => prod.id === this.productId
            )
        },
        prices() {
            return this.product?.merchant_prices || []
        },
        localCodes() {
            return this.prices.map(price => {
                return {
                    alternative_ean: price.alternative_ean,
                    merchant_id: price.merchant_id
                }
            })
        }
    },
    methods: {
        async checkIfEanExists() {
            if (!this.$store.getters.isProductEansPermission) return

            const isEveryCodeEmpty = this.localCodes.every(
                code => !code.alternative_ean
            )

            if (isEveryCodeEmpty) {
                this.$set(this.product, 'eanErrors', null)
                return
            }

            // avoid duplicates
            let codes = this.localCodes.map(code => code.alternative_ean)
            codes = [...new Set(codes)]

            const res = await this.$store.dispatch('checkIfEansExist', [
                {
                    alternative_ean: codes.join(','),
                    merchant_id: this.localCodes
                        .map(code => code.merchant_id)
                        .join(',')
                }
            ])

            let errors = null
            if (res.length) {
                errors = res.filter(error => error.ean !== this.product.ean)
            }

            this.$set(this.product, 'eanErrors', errors)
        },
        onMassPriceChange(price) {
            this.product.merchant_prices.forEach(merchant => {
                this.$set(merchant, 'promo_price', price)
            })
        },
        onMassLocalCodeChange(code) {
            this.product.merchant_prices.forEach(merchant => {
                this.$set(merchant, 'alternative_ean', code)
            })
        },
        saveChanges() {
            if (this.isMix) {
                this.form.step3.product_sets[0].products.value = this.tempSelectedProducts
            } else{
                this.form.step3.products.value = this.tempSelectedProducts
            }
        }
    },

    watch: {
        localCodes() {
            this.checkIfEanExists()
        }
    }
}
</script>
